import { InvitationB2bClientOnlyForOwnersComponent } from './components/only-for-owners/invitation-b2b-client-only-for-owners.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '@app/shared';
import { SharedSignupModule } from '@app/shared-signup/shared-signup.module';
import { CartState } from '@app/store/state/cart.state';
import {
  AvatarModule,
  ButtonLoaderModule,
  HeaderTitleModule,
  I18NModule,
  IkCardSelectableIconItemModule,
  InfoBoxModule,
  LoaderModule,
  ModalModule,
  ValidationCheckModule
} from '@infomaniak/angular-common';
import { IkCardSelectableModule } from '@infomaniak/ngx-card-selectable';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';
import { HeaderInvitationB2bPartnershipLogosModule } from '../invitation-b2b-shared/header-partnership-logos/header-invitation-b2b-partnership-logos.module';
import { InvitationB2BPageWrapperModule } from '../invitation-b2b-shared/page-wrapper/invitation-b2b-page-wrapper.module';
import { InvitationB2bClientDisplayPartnerInfosComponent } from './components/modals/display-partner-infos/invitation-b2b-client-display-partner-infos.component';
import { InvitationB2bClientComponent } from './invitation-b2b-client.component';
import { InvitationB2bClientHeaderPartnerInfosComponent } from './components/header-partner-infos/invitation-b2b-client-header-partner-infos.component';
import { InvitationB2bClientSelectAccountComponent } from './components/select-account/invitation-b2b-client-select-account.component';
import { InvitationB2bClientAccountListComponent } from './components/account-list/invitation-b2b-client-account-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InvitationB2bClientAccessListComponent } from './components/access-list/invitation-b2b-client-access-list.component';
import { InvitationB2bClientPaymentListComponent } from './components/payment-list/invitation-b2b-client-payment-list.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InvitationB2BInvitationAcceptedModule } from '../invitation-b2b-shared/invitation-accepted/invitation-b2b-accepted.module';
import { InvitationB2BInvitationRejectedModule } from '../invitation-b2b-shared/invitation-rejected/invitation-b2b-rejected.module';
import { InvitationB2bClientPaymentInfosComponent } from './components/payment-infos/invitation-b2b-client-payment-infos.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IkSelectPaymentChangeProfileReadModalComponent } from './components/payment-infos/modals/change-method-read-modal/ik-select-payment-change-profile-read-modal.component';
import {
  IkSelectPaymentChangeBillingAddressReadModalComponent
} from './components/payment-infos/modals/change-biilling-address-read-modal/ik-select-payment-change-biilling-address-read-modal.component';
import { InvitationB2BClientAlreadyCheckedComponent } from './components/already-checked/invitation-b2b-client-already-checked.component';
import { InvitationB2bClientWrongAccountComponent } from './components/wrong-account/invitation-b2b-client-wrong-account.component';
import { IkSelectPaymentChangeProfileEditModalComponent } from './components/payment-infos/modals/change-method-edit-modal/ik-select-payment-change-profile-edit-modal.component';
import {
  IkSelectPaymentChangeBillingAddressEditModalComponent
} from './components/payment-infos/modals/change-biilling-address-edit-modal/ik-select-payment-change-biilling-address-edit-modal.component';

@NgModule({
  declarations: [
    InvitationB2bClientComponent,
    InvitationB2bClientDisplayPartnerInfosComponent,
    InvitationB2bClientOnlyForOwnersComponent,
    InvitationB2bClientHeaderPartnerInfosComponent,
    InvitationB2bClientSelectAccountComponent,
    InvitationB2bClientAccountListComponent,
    InvitationB2bClientAccessListComponent,
    InvitationB2BClientAlreadyCheckedComponent,
    InvitationB2bClientPaymentListComponent,
    InvitationB2bClientPaymentInfosComponent,
    IkSelectPaymentChangeProfileReadModalComponent,
    IkSelectPaymentChangeBillingAddressReadModalComponent,
    IkSelectPaymentChangeProfileEditModalComponent,
    IkSelectPaymentChangeBillingAddressEditModalComponent,
    InvitationB2bClientWrongAccountComponent,
  ],
  imports: [
    CommonModule,
    I18NModule,
    TranslocoModule,
    NgxsModule.forFeature([CartState]),
    SharedModule,
    MatCardModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    LoaderModule,
    FormsModule,
    ReactiveFormsModule,
    ValidationCheckModule,
    MatButtonModule,
    AvatarModule,
    SharedSignupModule,
    HeaderTitleModule,
    ButtonLoaderModule,
    IkCardSelectableModule,
    IkCardSelectableIconItemModule,
    MatDialogModule,
    InvitationB2BPageWrapperModule,
    HeaderInvitationB2bPartnershipLogosModule,
    InvitationB2BInvitationAcceptedModule,
    InvitationB2BInvitationRejectedModule,
    ModalModule,
    InfoBoxModule,
  ],
  exports: [InvitationB2bClientComponent]
})
export class InvitationB2BClientModule {
}
